import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Page } from '../Models/page';
import { Product } from '../Models/product';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';


@Component({
  selector: 'product-pagination',
  templateUrl: '../Templates/product.pagination.html',
  styleUrls: ['../Styles/product.pagination.scss']
})


export class ProductPaginationComponent {

  constructor(private http: HttpClient) { }

  @Input()
  public products: Page<Product>;

  @Output()
  public pageChange: EventEmitter<string> = new EventEmitter();

  private list(url: string): Observable<Product[]> {

    return this.http.get<Product[]>(url).map(
      data =>
        {
          let products = new Page<Product>();

          for (let i= 0; i < data['results'].length; i++) {

            let product = new Product();

            product.setData(data['results'][i]);

            products.push(product);
          }

          products._links = data['_links'];
          products.count = data['count'];
          products.current = data['current'];
          products.pages = data['pages'];

          return products;
        }
    );
  }

  public nextPage(): void {

    this.pageChange.next(this.paramsFromUrl(this.products._links.next));
  }

  public prevPage(): void {

    this.pageChange.next(this.paramsFromUrl(this.products._links.previous));
  }

  public goPage(page: number): void {

    this.pageChange.next(this.paramsFromUrl(this.products._links['' + page]));
  }

  private paramsFromUrl(url: string): string {
    if (url && url.indexOf("?") > -1) {
      return url.split("?")[1];
    } else {
      return "";
    }
  }

  public listPages(): number[] {

    let pages : Array<number> = [];

    for (let i = 1; i <= this.products.pages; i++) {

      pages.push(i);
    }

    return pages;
  }

  public isCurrent(page: number): boolean {

    return page == this.products.current;
  }

  public hasPages(): boolean {
    return this.products.pages > 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/product.pagination.ts